<template>
  <div>
    <v-container grid-list-lg fluid>
        <v-layout row wrap>
        <v-flex lg12 md12 sm12>
            <v-layout row wrap>
                <v-flex lg3 md12 sm12 pr-6 pl-lg-6>
                    <mh-date-picker plabel="Từ ngày" v-model="dateRange.startDate" @onChangeDate="dateRange.startDate =$event"></mh-date-picker>
                </v-flex>
                <v-flex lg3 md12 sm12 pr-6>
                    <mh-date-picker plabel="Đến ngày" v-model="dateRange.endDate" @onChangeDate="dateRange.endDate =$event"></mh-date-picker>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg12 v-if="items">
                    <v-data-table hide-default-footer :headers="headers" :items="items" :options.sync="pagination" :server-items-length="items.length" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.report_date }}</td>
                                <td class="text-end">{{ item.total_qty | currency }}</td>
                                <td class="text-end">{{ item.total_qty_bought | currency }}</td>
                                <td class="text-end">{{ item.total_amount | currency }}</td>
                                <td class="text-end">{{ item.total_cost | currency }}</td>
                                <td class="text-end">{{ item.total_revenue | currency }}</td>
                            </tr>
                        </template>
                        <template v-slot:body.append>
                            <tr>
                                <td class="font-weight-bold">TỔNG</td>
                                <td class="text-end font-weight-bold">{{dic_summary.total_qty | currency}}</td>
                                <td class="text-end font-weight-bold">{{dic_summary.total_qty_bought | currency}}</td>
                                <td class="text-end font-weight-bold">{{ dic_summary.total_amount | currency }}</td>
                                <td class="text-end font-weight-bold">{{ dic_summary.total_cost | currency }}</td>
                                <td class="text-end font-weight-bold">{{ dic_summary.total_revenue | currency }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import MHDatePicker from "@/components/daterange/MHDatePicker";
import _ from "lodash";
import moment from "moment"
export default {
    components: {
        "mh-date-picker": MHDatePicker
    },
    data() {
        return {
            viewName: "bao-cao-loi-nhuan",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            pagination: {...configs.PAGINATION, sortBy: ["report_date"]}
        };
    },
    watch: {
        filter_params() {
            this.get_report();
        },
        pagination: {
            handler: function (val, oldVal) {
                this.get_report();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.reports.generals.data,
            loading: state => state.reports.loading,
        }),
        dic_summary() {
            return {
                'total_qty': _.sumBy(this.items, 'total_qty'),
                'total_qty_bought': _.sumBy(this.items, 'total_qty_bought'),
                'total_amount': _.sumBy(this.items, 'total_amount'),
                'total_cost': _.sumBy(this.items, 'total_cost'),
                'total_revenue': _.sumBy(this.items, 'total_revenue'),
            };
        },
        headers() {
            let tmp = [
                {
                    text: "Ngày",
                    value: "report_date",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "SL xuất",
                    value: "total_qty",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "SL mua",
                    value: "total_qty_bought",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng tiền xuất",
                    value: "total_amount",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng tiền mua",
                    value: "total_cost",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Chênh lệch",
                    value: "total_revenue",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                }

            ];
            return tmp;
        },
        filter_params() {
            return {
                pagination: this.pagination,
                'start_date': moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT), 
                'end_date': moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT)
            };
        }
    },
    methods: {
        get_report() {
            this.$store.dispatch("reports/get_general_report", this.filter_params );          
        }
    },
    mounted() {
        this.get_report();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.get_report);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
    }
};
</script>
<style scoped>
.rate-p {
    margin-bottom: 0px;
    margin-top: 16px;
}
.rate-p2 {
    margin-bottom: 16px;
    margin-top: 8px;
    color: rgb(168, 168, 168);
}
</style>